module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }, [_vm._v("pity this busy monster, manunkind,")])]), _c('a', {
    attrs: {
      "id": "piv"
    }
  }, [_c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("not. Progress is a comfortable disease: your victim(death and life safely beyond)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("plays with the bigness of his littleness—electrons deify one razorblade into a mountainrange; lenses extend")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("unwish through curving wherewhen till unwish returns on its unself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("A world of made is not a world of born—pity poor flesh")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("and trees, poor stars and stones, but never this fine specimen of hypermagical")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("ultraomnipotence. We doctors know")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-left": "2em",
      "text-indent": "-1em"
    }
  }, [_vm._v("a hopeless case if—listen: there’s a hell of a good universe next door; let’s go")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("—e e cummings")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6958c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface001.vue
// module id = 75
// module chunks = 0